import { useEffect, useState } from "react";
import { Table, Card, Button, message, Layout, Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Sidebar from "../layout/sidebar";
import useAuth from "../utils/useAuth";
import { getToken } from "../utils/auth";
import CargaUsuariosCsv from "./UsuariosCSV";

const { Content } = Layout;

export default function Usuarios() {
  useAuth();

  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/GetEbookByUser");
      setUsuarios(res.data);
    } catch (error) {
      message.error("No se pudieron cargar los usuarios");
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Filtro reutilizable por texto
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            size="small"
            icon={<SearchOutlined />}
            onClick={() => confirm()}
          >
            Buscar
          </Button>
          <Button size="small" onClick={clearFilters}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
  });

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Email",
      dataIndex: "correo",
      key: "correo",
      ...getColumnSearchProps("correo"),
    },
    {
      title: "Book ID",
      dataIndex: "bookId",
      key: "bookId",
      filters: [...new Set(usuarios.map((u) => u.bookId))].map((book) => ({
        text: book,
        value: book,
      })),
      onFilter: (value, record) => record.bookId === value,
    },
    {
      title: "Book Name",
      dataIndex: "bookName",
      key: "bookName",
      ...getColumnSearchProps("bookName"),
    },
  ];

  const token = getToken();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout style={{ marginLeft: 200, padding: 20 }}>
        <CargaUsuariosCsv />

        <Content>
          <Card
            title="Usuarios eBook"
            extra={
              <Button
                type="primary"
                onClick={() => navigate("/dashboard/usuarios/crear")}
              >
                Agregar Usuario
              </Button>
            }
            style={{ minHeight: "80vh", overflowX: "auto" }}
          >
            <Table
              dataSource={usuarios}
              columns={columns}
              loading={loading}
              rowKey="id"
              pagination={{ pageSize: 10 }}
            />
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
}
